import React from "react"

const ArrowIcon2 = ({ className }) => <svg viewBox="0 0 6 12" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.146469 0.146447C-0.048793 0.341709 -0.048793 0.658291 0.146469 0.853553L4.49314 5.20022C4.81121 5.51829 4.81121 6.04171 4.49314 6.35978L0.146469 10.7064C-0.048793 10.9017 -0.048793 11.2183 0.146469 11.4136C0.341731 11.6088 0.658314 11.6088 0.853576 11.4136L5.20024 7.06689C5.90884 6.35829 5.90884 5.20171 5.20024 4.49311L0.853576 0.146447C0.658314 -0.0488155 0.341731 -0.0488155 0.146469 0.146447Z" />
</svg>


export default ArrowIcon2
